<svg
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M14.9497 6.46446L13.5355 5.05025L10 8.58577L6.46449 5.05026L5.05027 6.46447L8.58579 9.99998L5.05024 13.5355L6.46445 14.9497L10 11.4142L13.5356 14.9498L14.9498 13.5355L11.4142 9.99998L14.9497 6.46446Z"
    fill="currentColor"
  />
</svg>
